interface WavArrayHeaderOptions {
  bytesPerSample: number;
  format: number;
  numChannels: number;
  numFrames: number;
  sampleRate: number;
}

export function buildWavHeader(opts: WavArrayHeaderOptions) {
  const numFrames = opts.numFrames;
  const numChannels = opts.numChannels || 2;
  const sampleRate = opts.sampleRate || 44100;
  const bytesPerSample = opts.bytesPerSample || 2;
  const format = opts.format;

  const blockAlign = numChannels * bytesPerSample;
  const byteRate = sampleRate * blockAlign;
  const dataSize = numFrames * blockAlign;

  const buffer = new ArrayBuffer(44);
  const dv = new DataView(buffer);

  let p = 0;

  function writeString(s: string) {
    for (let i = 0; i < s.length; i++) {
      dv.setUint8(p + i, s.charCodeAt(i));
    }
    p += s.length;
  }

  function writeUint32(d: number) {
    dv.setUint32(p, d, true);
    p += 4;
  }

  function writeUint16(d: number) {
    dv.setUint16(p, d, true);
    p += 2;
  }

  writeString("RIFF");
  writeUint32(dataSize + 32);
  writeString("WAVE");
  writeString("fmt ");
  writeUint32(16);
  writeUint16(format);
  writeUint16(numChannels);
  writeUint32(sampleRate);
  writeUint32(byteRate);
  writeUint16(blockAlign);
  writeUint16(bytesPerSample * 8);
  writeString("data");
  writeUint32(dataSize);

  return buffer;
}
